"use strict";

exports.__esModule = true;
exports.default = void 0;

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactEmotion = require("react-emotion");

var _Flex = _interopRequireDefault(require("../../layouts/Flex"));

var _Title = _interopRequireDefault(require("../typography/Title"));

var _Footer = _interopRequireDefault(require("../Footer"));

var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));

var _css;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var infoStyle = /*#__PURE__*/(0, _reactEmotion.css)((_css = {
  color: '#fff',
  fontSize: 13,
  fontWeight: 600
}, _css[(0, _mediaQueries.default)('lg')] = {
  textAlign: 'center',
  fontWeight: 100
}, _css));
var titleStyle = {
  margin: '0.9rem 0px'
};
var mask = /*#__PURE__*/(0, _reactEmotion.css)("height:20px;width:20px;border-radius:3px;background-color:rgba(255,255,255,0.1);margin:20px 10px 0 0;img{width:100%;}");
var imgPath = 'https://opensource.appbase.io/reactivesearch/images';

var FooterBrand = function FooterBrand(_ref) {
  var _css2, _css3;

  var brandLinksConfig = _ref.brandLinksConfig;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("img", {
    width: "100%",
    src: "https://cdn.jsdelivr.net/gh/appbaseio/cdn@dev/appbase/logos/reactivesearch-color.svg",
    alt: "appbase.io"
  }), _react.default.createElement("div", {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    (0, _reactEmotion.css)((_css2 = {
      textAlign: 'left',
      marginTop: '10px'
    }, _css2[(0, _mediaQueries.default)('lg')] = {
      textAlign: 'center',
      marginTop: '0'
    }, _css2))
  }, _react.default.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "mailto:info@appbase.io",
    className: infoStyle
  }, "info@appbase.io")), _react.default.createElement(_Flex.default, {
    alignItems: "center",
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    (0, _reactEmotion.css)((_css3 = {}, _css3[(0, _mediaQueries.default)('lg')] = {
      justifyContent: 'center'
    }, _css3))
  }, brandLinksConfig.map(function (brand) {
    return _react.default.createElement("a", {
      key: brand.title,
      target: "_blank",
      rel: "noopener noreferrer",
      href: brand.href
    }, _react.default.createElement("div", {
      className: mask
    }, _react.default.createElement("img", {
      alt: brand.title,
      srcSet: brand.image
    })));
  })));
};

FooterBrand.propTypes = {
  brandLinksConfig: (0, _propTypes.arrayOf)(_propTypes.object)
};

var AppFooter = function AppFooter(_ref2) {
  var _css5, _css6, _css7, _css8;

  var linksConfig = _ref2.linksConfig,
      brandLinksConfig = _ref2.brandLinksConfig,
      props = _objectWithoutProperties(_ref2, ["linksConfig", "brandLinksConfig"]);

  return _react.default.createElement("div", _extends({}, props, {
    className: /*#__PURE__*/(0, _emotion.css)("background-color:rgb(6,32,51)")
  }), _react.default.createElement(_Footer.default, {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    (0, _reactEmotion.css)((_css5 = {
      padding: '60px 0'
    }, _css5[(0, _mediaQueries.default)('md')] = {
      paddingBottom: '0'
    }, _css5))
  }, _react.default.createElement(_Footer.default.Brand, {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    (0, _reactEmotion.css)((_css6 = {}, _css6[(0, _mediaQueries.default)('lg')] = {
      display: 'none'
    }, _css6))
  }, _react.default.createElement(FooterBrand, {
    brandLinksConfig: brandLinksConfig
  })), _react.default.createElement(_Footer.default.Links, {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    (0, _reactEmotion.css)((_css7 = {}, _css7[(0, _mediaQueries.default)('lg')] = {
      width: '100%'
    }, _css7))
  }, linksConfig.map(function (footerList) {
    return _react.default.createElement(_Footer.default.List, {
      key: footerList.title
    }, _react.default.createElement(_Title.default, {
      style: _extends({}, titleStyle),
      className: "heading"
    }, footerList.title), footerList.list.map(function (list, index) {
      return (// eslint-disable-next-line
        _react.default.createElement("li", {
          key: index
        }, _react.default.createElement("a", _extends({}, list.openWithTab ? {
          target: '_blank',
          rel: 'noopener noreferrer' // prettier-ignore

        } : {}, {
          href: list.href
        }), list.title))
      );
    }));
  }))), _react.default.createElement("div", {
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    (0, _reactEmotion.css)((_css8 = {
      width: 200,
      margin: '0 auto',
      paddingBottom: 100,
      display: 'none'
    }, _css8[(0, _mediaQueries.default)('lg')] = {
      display: 'block'
    }, _css8))
  }, _react.default.createElement(FooterBrand, {
    brandLinksConfig: brandLinksConfig
  })));
};

AppFooter.defaultProps = {
  linksConfig: [],
  brandLinksConfig: [{
    title: 'Github',
    href: 'https://github.com/appbaseio/',
    image: imgPath + "/footer/Github@3x.svg 3x, " + imgPath + "/footer/Github@2x.png 2x, " + imgPath + "/footer/Github@1x.png"
  }, {
    title: 'Medium',
    href: 'https://medium.appbase.io/',
    image: imgPath + "/footer/Medium@3x.svg 3x, " + imgPath + "/footer/Medium@2x.png 2x, " + imgPath + "/footer/Medium@1x.png"
  }, {
    title: 'Twitter',
    href: 'https://twitter.com/appbaseio',
    image: imgPath + "/footer/Twitter%20Copy@3x.svg 3x, " + imgPath + "/footer/Twitter%20Copy@2x.png 2x, " + imgPath + "/footer/Twitter%20Copy@1x.png"
  }]
};
AppFooter.propTypes = {
  brandLinksConfig: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    title: _propTypes.string,
    href: _propTypes.string,
    image: _propTypes.string
  })),
  linksConfig: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    title: _propTypes.string,
    list: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      title: _propTypes.string,
      href: _propTypes.string,
      openWithTab: _propTypes.bool
    }))
  }))
};
var _default = AppFooter;
exports.default = _default;